// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","HasSeenAd":"cn_a bhh_fk bhh_vt bhh_xe bhh_h"};